import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HeroSection from '../components/home/HeroSection';
import ProductGrid from '../components/home/ProductGrid';
import FarmerList from '../components/home/FarmerList';
import EquipmentDealsSection from '../components/home/EquipmentDealsSection';
import Testimonials from '../components/home/Testimonials';
import FoodPackages from '../components/home/FoodPackages';
import RiceStoreHighlight from '../components/home/RiceStoreHighlighter';
import SeasonalSnippet from '../components/home/SeasonalSnippet';
import { scrollToHomeSection } from '../utils/scrollToHomeSection';

export default function HomePage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const sectionId = location.state?.scrollToSection;
    if (!sectionId) return;

    const timer = window.setTimeout(() => {
      scrollToHomeSection(sectionId);
      navigate('/', { replace: true, state: null });
    }, 60);

    return () => window.clearTimeout(timer);
  }, [location.state, navigate]);

  return (
    <main>
      <HeroSection />
      <RiceStoreHighlight />
      <ProductGrid />
      <SeasonalSnippet />
      <FarmerList />
      <EquipmentDealsSection />
      <Testimonials />
      <FoodPackages />
    </main>
  );
}
